import { styled } from '@mui/material';

export const PREFIX = 'GridDialogValueViewer';

export const classes = {
  valueViewer: `${PREFIX}-valueViewer`,
  valueContainer: `${PREFIX}-valueContainer`,
  margin: `${PREFIX}-margin`,
  dropdownIcon: `${PREFIX}-dropdownIcon`,
  actionBtn: `${PREFIX}-actionBtn`,
  dialogIcon: `${PREFIX}-dialogIcon`,
};

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.valueViewer}`]: {
    position: 'absolute',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    right: 0,
    top: 0,
  },

  [`& .${classes.valueContainer}`]: {
    position: 'relative',
    height: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },

  [`& .${classes.margin}`]: {
    marginRight: theme.spacing(2.5),
  },

  [`& .${classes.dropdownIcon}`]: {
    paddingTop: '4px',
    paddingLeft: '5px',
    marginRight: '2px',
  },

  [`& .${classes.actionBtn}`]: {
    position: 'absolute',
    top: '2px',
    right: 0,
  },

  [`& .${classes.dialogIcon}`]: {},
}));
